// for local development
// export const urlBase = 'http://127.0.0.1:5001/applicant-portal-01/us-central1/api/';
export const urlBase = window.grapp.environment === 'development' ? 'http://127.0.0.1:5001/applicant-portal-01/us-central1/api/' : 'https://api-c2rpbfhl6a-uc.a.run.app/';
export const defaultOptions = {};

export const get = async (path, callback, options = defaultOptions) => {
  try {
    const request = await fetch(`${urlBase}${path}`);
    const response = await request.json();
    console.log('APIClient get response: ', response);

    if (callback) {
      callback(response)
    } else {
      return response;
    }
  } catch (error) {
    console.log('APIClient get error: ', { path, options, error });
    return;
  }
}

export const post = async (path, body, callback, options = defaultOptions) => {
  try {
    const request = await fetch(`${urlBase}${path}`, {
      method: 'post',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      ...defaultOptions,
    });
    const response = await request.json();
    // console.log('APIClient get response: ', response);

    if (callback) {
      callback(response)
    } else {
      return response;
    }
  } catch(err) {
    console.log('APIClient post error: ', { path, options, err });
  }
}
